import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { Router } from '@angular/router';
import { Assinante } from '../assinantes/assinante.model';
import { AssinantesService } from './../assinantes/assinantes.service';


@Component({
  selector: 'ntc-contratos',
  templateUrl: './contratos.component.html',
  styleUrls: ['./contratos.component.css']
})
export class ContratosComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  contratos: any = {};
  listaAssinante: Assinante[];
  listaSituacao = [
    {Id: 'A', Descricao: 'Ativo'},
    {Id: 'I', Descricao: 'Inativo'},
    {Id: 'B', Descricao: 'Bloqueado'}
  ];

  gridMode: string;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridContrato = null;
  editOptionsGridContrato = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Contrato',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private assinantesService: AssinantesService,
    private router: Router
  ) {
    this.assinantesService.getAssinantes().subscribe(assinantes => {
      this.listaAssinante = assinantes;
      this.montaColunasGrid();
    });

    this.gridMode = GridConfig.gridMode;
    this.showFilterRow =  GridConfig.showFilterRow;
    this.showHeaderFilter =  GridConfig.showHeaderFilter;
    this.alturaGrid = calculaAlturaGrid();

    this.contratos = new CustomStore({
      remove: function (key) {
        return http.delete(`${NTECH_API}/contratos/${encodeURIComponent(key.Id)}`).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/contratos/`)
            .toPromise()
            .then(response => {
                const json = response.json();
                return json;
            })
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onEditingStart(e) {
    this.router.navigate([`/contrato/${e.data.Id}`]);
  }

  onInitNewRow(e) {
    this.router.navigate(['/contrato']);
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  textoSumario(e) {
    return 'Registros: ' + e.value;
  }

  montaColunasGrid() {
    this.colunasGridContrato = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'IdAssinante',
        dataType: 'string',
        caption: 'Assinante',
        lookup: {
          dataSource: this.listaAssinante,
          displayExpr: 'Pessoa.Nome',
          valueExpr: 'Id'
        }
      },
      {
        dataField: 'SituacaoContrato',
        dataType: 'string',
        caption: 'Situação',
        lookup: {
          dataSource: this.listaSituacao,
          displayExpr: 'Descricao',
          valueExpr: 'Id'
        }
      }
    ];
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
  }

}

/*
import { Component, OnInit } from '@angular/core';
import { DxDataGridModule } from 'devextreme-angular';
import { Contrato } from './../contrato/contrato.model';
import { ContratosService } from './contratos.services';
import { Router } from '@angular/router';
import { Cidade } from '../cidades/cidade.model';
import { CidadesService } from './../cidades/cidades.service';
import { Assinante } from '../assinantes/assinante.model';
import { AssinantesService } from './../assinantes/assinantes.service';
import { GridConfig } from './../app.config';

@Component({
  selector: 'ntc-contratos',
  templateUrl: './contratos.component.html',
  styleUrls: ['./contratos.component.css']
})
export class ContratosComponent implements OnInit {

  contratos: Contrato[];
  listaCidade: Cidade[];
  listaAssinante: Assinante[];

  //gridMode: string;
  currentFilter: any;
  showFilterRow: boolean;
  showHeaderFilter: boolean;

  constructor(
    private contratosService: ContratosService,
    private cidadesService: CidadesService,
    private assinantesService: AssinantesService,
    private router: Router
  ) {
    //this.gridMode = GridConfig.gridMode;
    this.showFilterRow =  GridConfig.showFilterRow;
    this.showHeaderFilter =  GridConfig.showHeaderFilter;
  }

  ngOnInit() {
    this.contratosService.getContratos().subscribe(contratos => this.contratos = contratos);
    this.cidadesService.getCidades().subscribe(cidades => this.listaCidade = cidades);
    this.assinantesService.getAssinantes().subscribe(assinantes => this.listaAssinante = assinantes);
  }

  onSelectionChanged (e) { // Handler of the "selectionChanged" event
    let currentSelectedRowKeys = e.currentSelectedRowKeys;
    let currentDeselectedRowKeys = e.currentDeselectedRowKeys;
    let allSelectedRowKeys = e.selectedRowKeys;
    let allSelectedRowsData = e.selectedRowsData;
    
    this.router.navigate([`/contrato/${currentSelectedRowKeys}`]);
    console.log('Linha selecionada:' + currentSelectedRowKeys);
  }

  addContrato(){
    this.router.navigate(['/contrato/']);
  }

}
*/


// WEBPACK FOOTER //
// ./src/app/contratos/contratos.component.ts